export default __webpack_public_path__ + "static/media/ml.4a96b708.svg";